var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"outlined":"","color":"secondary"}},[_c('v-window',{model:{value:(_vm.about),callback:function ($$v) {_vm.about=$$v},expression:"about"}},_vm._l((_vm.items),function(panel,key){return _c('v-window-item',{key:`card-${key + 1}`},[_c(panel.component,{tag:"component"})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }